import { Grid2 as Grid } from "@mui/material";
import React, { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

type HtmlEvent = ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;

const MeasureFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath }) => {
  const { control } = useFormContext();
  const handleChange = (e: HtmlEvent, fieldOnChange: (e: any) => void) => {
    fieldOnChange(Number(e.target.value));
  };
  return (
    <Grid
      container
      spacing={1}
      key={getFieldPath([extractionId, extractionPath])}
    >
      <Grid size={7}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.value`}
          control={control}
          label="Valeur"
          type="number"
          handleChange={handleChange}
          rules={{ valueAsNumber: true }}
        />
      </Grid>
      <Grid size={5}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.unit`}
          control={control}
          label="Unité"
        />
      </Grid>
    </Grid>
  );
};

export default MeasureFormFields;
